import { render, staticRenderFns } from "./CustomerInteractionComponent.vue?vue&type=template&id=92882fc6&scoped=true"
import script from "./CustomerInteractionComponent.vue?vue&type=script&lang=js"
export * from "./CustomerInteractionComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerInteractionComponent.vue?vue&type=style&index=0&id=92882fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92882fc6",
  null
  
)

export default component.exports